import React from 'react';
import { View } from 'react-native';

import { overflow, rounded } from '../../style-utils';
import { AnimatedCardActions } from './animated-card-actions';
import AnimatedCardBackground from './animated-card-background';
import { AnimatedCardBody } from './animated-card-body';
import { AnimatedCardContext } from './animated-card-context';
import { AnimatedCardHeader } from './animated-card-header';
import type { AnimatedCardProps } from './animated-card-types';

export const AnimatedCard: AnimatedCardProps = ({
  children,
  animationRef,
  backgroundColor,
  style,
  onLayout,
}): JSX.Element => (
  <AnimatedCardContext.Provider value={animationRef}>
    <View style={[style, rounded(8), overflow('hidden')]} onLayout={onLayout}>
      <AnimatedCardBackground
        animationRef={animationRef}
        backgroundColor={backgroundColor}
      />
      {children}
    </View>
  </AnimatedCardContext.Provider>
);

AnimatedCard.Header = AnimatedCardHeader;
AnimatedCard.Body = AnimatedCardBody;
AnimatedCard.Actions = AnimatedCardActions;

export default AnimatedCard;
